import React from "react";
const MapControls = (props) => {
    const {children} = props;

    return <div>{ React.Children.map(children, (child, index) => {
        if (React.isValidElement(child)) {
            const ops = Object.assign({},props)
            delete ops.children;
            return React.cloneElement(child, { ...ops });
        }
        return child;
    })}</div>;
};
export default MapControls;
